import i18n from "@/i18n";
import _ from "@/boot/lodash";
import { HookCodes } from "@/data/enums/hooks";
import { createEventFunc, EventMapType, HookEventSlot, icon } from "./utils";

const createEventMap: EventMapType = (hookId, payload = {}) => ({
  [hookId]: {
    name: i18n.t(`_hook.${hookId}_name`).toString(),
    event: createEventFunc({
      ...payload,
      path: `_hook.${hookId}`,
      slots: event => {
        // Deleted assets
        if (_.isNull(event.object)) {
          return [
            {
              slot: "vaultType",
              is: "span",
              message:
                hookId === HookCodes.CLIENT_VAULT_ASSET_DECRYPTED
                  ? i18n.t("_.vault.vault_secret")
                  : i18n.t("_.vault.vault_asset")
            }
          ] as HookEventSlot[];
        }

        // Lead assets
        if (event.object.lead_id) {
          return [
            {
              slot: "vaultType",
              is: "span",
              message: event.object.encrypted
                ? i18n.t("_.vault.lead_secret")
                : i18n.t("_.vault.lead_note")
            }
          ] as HookEventSlot[];
        }

        // Contract product assets
        if (event.object.contract_product_id) {
          return [
            {
              slot: "vaultType",
              is: "span",
              message: event.object.encrypted
                ? i18n.t("_.vault.product_secret")
                : i18n.t("_.vault.product_note")
            }
          ] as HookEventSlot[];
        }

        // Client assets
        return [
          {
            slot: "vaultType",
            is: "span",
            message: event.object.encrypted
              ? i18n.t("_.vault.client_secret")
              : i18n.t("_.vault.client_note")
          }
        ] as HookEventSlot[];
      }
    })
  }
});

export default {
  ...createEventMap(HookCodes.CLIENT_VAULT_ASSET_CREATED, {
    icon: icon.success
  }),
  ...createEventMap(HookCodes.CLIENT_VAULT_ASSET_DECRYPTED, {
    icon: icon.info
  }),
  ...createEventMap(HookCodes.CLIENT_VAULT_ASSET_DELETED, {
    icon: icon.danger
  }),
  ...createEventMap(HookCodes.CLIENT_VAULT_ASSET_UPDATED, {
    icon: icon.info
  })
};
